module.exports = __webpack_public_path__ + "static/media/icon_organization.efece97b.svg";